import React from 'react';
import { Activity, Heart, Zap, Footprints } from 'lucide-react';
import { MetricCard } from '../MetricCard';
import { useMetricStore } from '../../store/metricStore';
import { CustomizeMetricsButton } from './CustomizeMetricsButton';
import { HealthMetrics } from '../../types/health';

interface MetricTilesProps {
  metrics: HealthMetrics;
}

export function MetricTiles({ metrics }: MetricTilesProps) {
  const { metrics: metricTiles } = useMetricStore();

  const enabledMetrics = metricTiles
    .filter(m => m.enabled)
    .sort((a, b) => a.order - b.order);

  const getMetricConfig = (id: string) => {
    switch (id) {
      case 'steps':
        return {
          title: "Steps",
          current: metrics.steps.current,
          previous: metrics.steps.yesterday,
          unit: "steps",
          icon: <Footprints className="w-5 h-5" />,
          color: "bg-primary/20 text-primary"
        };
      case 'calories':
        return {
          title: "Calories",
          current: metrics.calories.current,
          previous: metrics.calories.yesterday,
          unit: "cal",
          icon: <Activity className="w-5 h-5" />,
          color: "bg-orange-500/20 text-orange-500"
        };
      case 'resting-hr':
        return {
          title: "Resting HR",
          current: 62,
          previous: 64,
          unit: "bpm",
          icon: <Heart className="w-5 h-5" />,
          color: "bg-red-500/20 text-red-500"
        };
      case 'vo2-max':
        return {
          title: "VO2 Max",
          current: 48.5,
          previous: 48.0,
          unit: "ml/kg/min",
          icon: <Zap className="w-5 h-5" />,
          color: "bg-purple-500/20 text-purple-500"
        };
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <CustomizeMetricsButton />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {enabledMetrics.map((tile) => {
          const config = getMetricConfig(tile.id);
          if (!config) return null;

          return (
            <MetricCard
              key={tile.id}
              title={config.title}
              current={config.current}
              previous={config.previous}
              unit={config.unit}
              icon={config.icon}
              color={config.color}
            />
          );
        })}
      </div>
    </div>
  );
}